import React from 'react';
import { Image } from 'react-konva';
import {
  isMobileTablet,
} from '../../library/calc';

const adjustTop = 22.5;
const adjustLeft = 24.6;
export class More extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      fileName: 'moretabImage',
    }
  }

  swapImage({fileName}){
    this.setState({fileName});
  }

  render() {

    let content = 'New profiles have been added.  Click to reload the tree.';

    if( typeof(window.trl) !== 'undefined' ) content = window.trl(content, 'profile action')

    let {
      reloadFocusAndGotoHighlight,
      left,
      top,
      node,
      nodeObj,
      cursorBecomesMove,
      cursorBecomesPointer,
      stopStageClickPropagation,
      userTouchedNode,
      hideMatchBubble,
      showToolTipFor,
      hideToolTip,
    } = this.props;

    left += adjustLeft;
    top += adjustTop + 7.5;

    return (
        <Image
          image={this.props[`${this.state.fileName}`]}
          scaleX={.1}
          scaleY={.1}
          width={21*10}
          height={5.5*10}
          x={left}
          y={top}

          onTouchStart={()=>{
            userTouchedNode({
              node,
              callback: ()=>{
                if(isMobileTablet()) {
                  stopStageClickPropagation({fromWhere: 'addNodeComponent'});
                  hideToolTip();
                  // window.reloadTree({focus_pr_id: pr_id})
                  // window.location.reload();
                  const pr_id = nodeObj.pr_id;
                  reloadFocusAndGotoHighlight({prIdToTeleport: pr_id});
                  return;
                }
              },
              fromWhere: 'addnode component'});
          }}

          onMouseover={()=>{
            hideMatchBubble();
          }}

          onClick={(evt)=>{
            stopStageClickPropagation({fromWhere: 'addNodeComponent'});
            const pr_id = nodeObj.pr_id;
            hideToolTip();
            // window.reloadTree({focus_pr_id: pr_id})
            reloadFocusAndGotoHighlight({prIdToTeleport: pr_id});
            // window.location.reload();
          }}

          onMouseenter={()=>{

            cursorBecomesPointer();

            let shift = {
                  left: 29,
                  top: 2,
                }

              showToolTipFor({
                node,
                placement: 'under',
                shiftLeftOnToolTip: shift.left,
                shiftTopOnToolTip: shift.top,
                bubbleWidth: 40,
                content,
                runTranslatePhraseInToolTip: false,
              })

          }}
          onMouseleave={()=>{
            cursorBecomesMove();
            hideToolTip();
          }}
        />
    );
  }
}

